<template>
  <div style="min-height: 92vh">
    <h3>Proveedores</h3>
    <uv-data-table
      :config="config"
      :data="Proveedores"
      :pageRows="15"
      @buttonClick="dtButtonClick"
      @buttonOptClick="optButtonClick"
    ></uv-data-table>
    <modal v-model="showModal" :showFooter="false" title="Proveedores">
      <ProveedoresForm
        :edit="editMode"
        @toggle="toggleModal"
        :key="formIndex"
        :dataEdit="editData"
        @successData="successData"
      ></ProveedoresForm>
    </modal>
  </div>
</template>

<style></style>

<script>
import modal from "../../MainComponents/modal.vue";

import uvDataTable from "../../MainComponents/DataTable.vue";
import ProveedoresForm from "./ProveedoresForm.vue";

export default {
  name: "ProveedoresCRUD",
  components: {
    modal,
    uvDataTable,
    ProveedoresForm,
  },
  props: [],
  data() {
    return {
      self: this,
      showModal: false,
      formKey: 0,
      Proveedores: [],
      formIndex: 0,
      editMode: false,
      editData: [],
      hoteles: [],
      usuarios: [],
      editedHotel: {},
      zonas: [],
      config: {
        selectableRow: true,
        allowExport: true,
        rawText: "Proveedores",
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        orderByCol: { Field: "", Type: "Asc" },
        buttons: [
          {
            text: "Agregar",
            icon: "lni lni-plus",
            buttonId: "addCategoria",
          },
          {
            text: "Editar",
            icon: "lni lni-pencil-alt",
            buttonId: "editCategoria",
            require: true,
          },
          /* {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deleteCategoria",
            require: true,
          },*/
        ],
        fields: [
          {
            title: "Nombre",
            dataName: "Nombre",
            text: "Nombre",
            value: "nom",
          },
          {
            text: "RFC",
            value: "rfc",
          },
        ],
      },
    };
  },
  methods: {
    async getZonasImpresion() {
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "/PDV/ZonasImpresion"
        );
      if (snapshot.exists()) {
        this.zonas = [];
        this.zonas.push({ Id: "TICKET-PRINTER", nomb: "Default" });
        Object.keys(snapshot.val()).forEach((id) => {
          const toAdd = snapshot.val()[id];
          if (toAdd) {
            toAdd.Id = id;
            this.zonas.push(toAdd);
          }
        });
      }
    },
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "addCategoria") {
        this.formIndex++;
        this.editMode = false;
        this.showModal = true;
      }
      if (buttonId == "deleteCategoria") {
        this.deleteCategoria(idSelected[0]);
      }
      if (buttonId == "editCategoria") {
        this.formIndex++;
        this.editMode = true;
        this.editData = this.getCategoryById(idSelected[0]);
        this.$pgsHelper.log(this.editData);
        this.showModal = true;
      }
    },
    optButtonClick(buttonId, ref) {
      if (buttonId == "editPrice") {
        this.editedHotel = this.getHotelinfoById(ref);
        this.toggleModal(true);
      }
    },
    getCategoryById(code) {
      let itemIndex = this.$_.findIndex(this.Proveedores, { id: code });
      if (itemIndex >= 0) {
        return this.Proveedores[itemIndex];
      }

      return false;
    },
    successData(data, doAction) {
      if (doAction == "CREATE") {
        this.createCate(data);
      } else if (doAction == "EDIT") {
        this.editCate(data);
      }
    },
    createCate(datos) {
      let sendData = {
        nom: datos.proveedor,
        rfc: datos.rfc,
        coe: null,
        dps: datos.dps,
        tlf: null,
      };
      this.$swal({
        title: "¿Deseas crear este nuevo proveedor?",
        text: "Se registrara el proveedor con los datos indicados ",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("AMC-Provedores-createProvedor", sendData)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          this.$emit("reloadClient");
          if (result.value.data.ok) {
            this.$pgsHelper.log(result.value);
            this.$swal({
              title: "Guardado",
              text: "El proveedor se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.toggleModal(false);
              this.getProveedores();
            });
          } else {
            this.$swal(
              "Error guardando el proveedor",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    editCate(datos) {
      let sendData = {
        id: datos.Id,
        nom: datos.proveedor,
        rfc: datos.rfc,
        coe: null,
        dps: datos.dps,
        tlf: null,
      };

      this.$swal({
        title: "¿Deseas modificar la información del proovedor?",
        text: "",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("AMC-Provedores-updateProvedor", sendData)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          this.$emit("reloadClient");
          if (result.value.data.ok) {
            this.$pgsHelper.log(result.value);
            this.$swal({
              title: "Guardado",
              text: "El proveedor se modifico correctamente",
              icon: "success",
            }).then(() => {
              this.toggleModal(false);
              this.getProveedores();
            });
          } else {
            this.$swal(
              "Error saving Categoria",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    async deleteCategoria(id) {
      this.$swal({
        title: "¿Deseas eliminar esta categoria?",
        text: "Se eliminara permanentemente",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          let data = { Id: id };
          return await this.$store.getters.getFirebaseApp.fba
            .call("PDV-Productos-deleteCategoria", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Proveedor eliminado",
              "El proveedor se elimino correctamente",
              "success"
            );
            this.getProveedores();
          } else {
            this.$swal("Error deleting data", result.value.data.error, "error");
          }
        }
      });
    },
    toggleModal(open) {
      this.showModal = open;
    },
    async getProveedores() {
      this.Proveedores = [];
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "AMC/Provedores"
        );

      let Categories = [];
      Categories = this.$pgsHelper.ArrayObjectToArray(data.val());
      Categories.forEach((categories) => {
        this.Proveedores.push(categories);
      });
    },
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    this.getZonasImpresion();
    this.getProveedores();
  },
};
</script>
